import { useNavigate } from "react-router";
import { usePrefs } from "../../lib/prefs";
import { Button } from "../../components/ui/Button";
import { Dialog } from "../../components/ui/Dialog";
import { fixedShortcuts, isSingleKey, KEYBIND_GROUPS, KEYBIND_LABELS } from "../settings/keybinds";
import { Kbd, Keys } from "../settings/shared";

/** Ctrl/Cmd+/: every shortcut, generated from the current bindings. */
export function ShortcutHelp({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  const prefs = usePrefs();
  const navigate = useNavigate();
  const fixed = fixedShortcuts({ enterToSend: prefs.enterToSend });
  const fixedGroups = [...new Set(fixed.map((f) => f.group))];
  const row = (label: string, keys: React.ReactNode, off?: boolean) => (
    <li key={label} className="flex min-h-9 items-center justify-between gap-4 py-1">
      <span className={off ? "text-sm text-fg-3" : "text-sm text-fg-2"}>{label}</span>
      {keys}
    </li>
  );
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="Keyboard shortcuts"
      size="xl"
      footer={
        <Button
          variant="ghost"
          onClick={() => {
            onOpenChange(false);
            navigate("/settings/keyboard");
          }}
        >
          Customise shortcuts
        </Button>
      }
    >
      <div className="grid gap-x-10 gap-y-5 sm:grid-cols-2">
        {KEYBIND_GROUPS.map((g) => (
          <section key={g.title}>
            <h3 className="mb-1 text-xs font-medium text-fg-3">{g.title}</h3>
            <ul className="divide-y divide-line">
              {g.actions.map((a) => {
                const combo = prefs.keybinds[a];
                const off = !combo || (!prefs.singleKeyShortcuts && isSingleKey(combo));
                return row(KEYBIND_LABELS[a], off ? <span className="text-xs text-fg-3">{combo ? "Off" : "Not set"}</span> : <Kbd combo={combo} />, off);
              })}
            </ul>
          </section>
        ))}
        {fixedGroups.map((g) => (
          <section key={g}>
            <h3 className="mb-1 text-xs font-medium text-fg-3">{g}</h3>
            <ul className="divide-y divide-line">{fixed.filter((f) => f.group === g).map((f) => row(f.label, <Keys keys={f.keys} />))}</ul>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
